<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>流程模板</el-breadcrumb-item>
      <el-breadcrumb-item>管理工序</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-button type="primary" plain size="mini" @click="addRow"
        >添加行</el-button
      >
      <el-button type="primary" plain size="mini" @click="addColumn"
        >添加列</el-button
      >
      <div style="width: 100%; overflow-x: scroll">
        <el-table
          size="mini"
          class="mt-10 node-table"
          :style="`width: auto; min-width:${(headers.length + 1) * 150}px`"
          :data="tableData"
          border
          :key="tableKey"
        >
          <el-table-column
            align="center"
            :label="node.name"
            width="150"
            :key="columnIndex"
            v-for="(node, columnIndex) in headers"
          >
            <template slot-scope="scope" slot="header">
              <div v-if="node.edit">
                <el-input
                  class="table-input"
                  v-model="node.name"
                  @change="saveName(-1, columnIndex)"
                  @blur="inputBlur($event, -1, columnIndex)"
                  :ref="`table0${columnIndex}`"
                  placeholder="点击输入工序"
                ></el-input>
              </div>
              <div v-else class="edit-container">
                <div @click="inputEdit(-1, columnIndex)">
                  {{ node.name }}
                </div>
                <el-popconfirm
                  v-if="columnIndex != 0"
                  title="确定删除吗？"
                  @confirm="deleteNode(-1, columnIndex)"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </el-popconfirm>
              </div>
            </template>
            <template slot-scope="scope">
              <div v-if="scope.row.values[columnIndex].edit">
                <el-input
                  :type="columnIndex == 0 ? 'text' : 'number'"
                  class="table-input"
                  v-model="scope.row.values[columnIndex].value"
                  @change="saveName(scope.$index, columnIndex)"
                  @blur="inputBlur($event, scope.$index, columnIndex)"
                  @input.native="
                    columnIndex == 0
                      ? ''
                      : (scope.row.values[columnIndex].value = scope.row.values[
                          columnIndex
                        ].value.replace(/[^0-9]/g, ''))
                  "
                  :placeholder="columnIndex == 0 ? '型号' : '工时'"
                  :ref="`table${scope.$index + 1}${columnIndex}`"
                ></el-input>
              </div>
              <div class="edit-container" v-else>
                <div
                  :class="{ manhour: columnIndex > 0 }"
                  @click="inputEdit(scope.$index, columnIndex)"
                >
                  {{ scope.row.values[columnIndex].value }}
                </div>
                <el-popconfirm
                  title="确定删除吗？"
                  v-if="columnIndex == 0"
                  @confirm="deleteNode(scope.$index, columnIndex)"
                >
                  <el-button
                    slot="reference"
                    size="mini"
                    type="text"
                    icon="el-icon-delete"
                    circle
                  ></el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { processList, processCreate } from '@/service/getData'

export default {
  data() {
    return {
      headers: [],
      tableData: [],
      tableKey: Math.random(),
    }
  },
  created() {
    this.getData()
  },

  methods: {
    async getData() {
      let res = await processList()
      this.formatTableData(res.data)
    },

    formatTableData(processes) {
      let headers = [{ name: '钻头型号', edit: false }]
      let tableData = []
      processes.map((item, index) => {
        headers.push({
          id: item.id,
          name: item.name,
          edit: false,
        })

        if (index == 0) {
          for (const size in item.sizes) {
            tableData.push({
              values: [{ value: size, edit: false }],
              sort: item.sizes[size].sort,
            })
          }
        }

        tableData.map((row) => {
          let size = row.values[0].value
          row.values.push({ value: item.sizes[size].val, edit: false })
        })
      })

      this.headers = headers
      this.tableData = tableData.sort(function (x, y) {
        return x.sort - y.sort
      })

      this.tableKey = Math.random()
    },
    inputEdit(rIndex, cIndex) {
      if (rIndex == -1 && cIndex == 0) return

      if (rIndex == -1) {
        //表头
        this.headers[cIndex].edit = true
      } else {
        //表格
        this.tableData[rIndex].values[cIndex].edit = true
      }

      let ref = rIndex == -1 ? `table0${cIndex}` : `table${rIndex + 1}${cIndex}`
      let _this = this
      this.$nextTick(() => {
        _this.$refs[ref][0].$el.children[0].focus()
      })
    },
    inputBlur(e, rIndex, cIndex) {
      if (rIndex == -1) {
        //表头
        if (!this.headers[cIndex].name) {
          this.deleteTableData(cIndex, 'header')
        } else {
          this.headers[cIndex].edit = false
        }
      } else {
        //表格
        if (cIndex == 0 && !this.tableData[rIndex].values[cIndex].value) {
          this.deleteTableData(rIndex)
        } else {
          this.tableData[rIndex].values[cIndex].edit = false
        }
      }
    },

    deleteTableData(index, t = '') {
      if (t == 'header') {
        this.headers.splice(index, 1)
        this.tableData.map((item) => {
          item.values.splice(index, 1)
        })
      } else {
        this.tableData.splice(index, 1)
      }

      this.tableKey = Math.random()
    },

    addRow() {
      let row = { values: [] }
      for (let index = 0; index < this.headers.length; index++) {
        row.values.push({
          value: index == 0 ? '' : 0,
          edit: index == 0,
        })
      }
      this.tableData.push(row)

      let _this = this
      this.$nextTick(() => {
        _this.$refs[
          `table${_this.tableData.length}0`
        ][0].$el.children[0].focus()
      })
    },
    addColumn() {
      this.headers.push({ name: '', edit: true })
      this.tableData.map((row) => {
        row.values.push({ value: 0, edit: false })
        return row
      })

      let _this = this
      this.$nextTick(() => {
        _this.$refs[
          `table0${_this.headers.length - 1}`
        ][0].$el.children[0].focus()
      })
    },

    deleteNode(rindex, cindex) {
      if (rindex == -1) {
        this.deleteTableData(cindex, 'header')
      } else {
        this.deleteTableData(rindex)
      }
      // this.saveName()
    },

    async saveName(rindex, cindex) {
      if (this.headers.length < 2) return

      let data = { processes: [] }
      this.headers.map((item, index) => {
        if (index > 0) {
          let sizes = {}
          this.tableData.map((size, rindex) => {
            sizes[size.values[0].value] = {
              sort: rindex + 1,
              val: size.values[index].value.toString(),
            }
          })
          data.processes.push({
            id: item.id || 0,
            name: item.name,
            sizes: sizes,
          })
        }
      })

      let res = await processCreate(data)
      this.formatTableData(res.data)
    },
  },
}
</script>

<style scoped>
.table-input {
  width: 100%;
  text-align: center;
}

.edit-container {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: center;
  align-content: center;
}

.manhour {
  width: 100%;
}
.node-table {
  max-width: 10000px;
}
</style>

<style>
.node-table input {
  text-align: center;
}
.readonly input {
  border: none !important;
}
</style>